// Location: src/styles/footerStyles.js
// Date: 20240929
// Author: R Matthews
// Purpose: Styles for footer components

import { makeStyles, tokens } from '@fluentui/react-components';
import { rhemlabs } from '../theme';

export const useFooterStyles = makeStyles({
  footerTop: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: tokens.spacingS,
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  socialLinks: {
    display: 'flex',
    gap: tokens.spacingM,
  },
  footerMain: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: tokens.spacingM,
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  footerColumn: {
    flex: 1,
    textAlign: 'left',
    '@media (max-width: 768px)': {
      textAlign: 'center',
    },
  },
  footerHeading: {
    fontWeight: tokens.fontWeightBold,
    marginBottom: tokens.spacingS,
  },
  footerBase: {
    textAlign: 'center',
    padding: tokens.spacingS,
  },
  footer: {
    padding: tokens.spacingS,
  },
});